<template>
  <my_radio
    :titleWidth="titleWidth"
    :title="title"
    hiddenIsShow="false"
    :selectValue.sync="boxShadow.radio_val"
    :default-title="defaultTitle"
    :self-title="selfTitle"
  >
    <div slot="pull_down_control" class="shadow-setting">
      <div>
        <span class="my-label" :style="{width: !Number.isNaN(Number(titleWidth)) ? titleWidth + 'px' : titleWidth}">{{$t('view_back_top_edit_99')}}</span>
        <my_color
          class="color-picker"
          :title="color_title"
          :color.sync="boxShadow.custom.color"
        ></my_color>
        <my_color
          class="color-picker"
          :title="secolor_title || $t('base_options_config_1838')"
          :color.sync="boxShadow.custom.seColor"
          v-if="hasSeColor"
        ></my_color>
      </div>
      <my_slider
        class="num_slider num-blur"
        :titleWidth="titleWidth"
        :title="$t('widgets_basic_classification_edit_465')"
        :value.sync="boxShadow[boxShadow.radio_val].blur"
        :min="min"
        :max="max"
        symbol="px"
      ></my_slider>
    </div>
  </my_radio>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "my_simple_box_shadow.vue",
  props: {
    defaultTitle: { // 默认设置标题
      type: String,
      default: i18n.t('view_back_top_edit_103')
    },
    selfTitle: { // 自定义设置标题
      type: String,
      default: i18n.t('view_back_top_edit_102')
    },
    titleWidth: {
      type: [Number, String],
      default: '45'
    },
    title: {
      type: String,
      default: i18n.t('widgets_basic_floating_frame_edit_532')
    },
    option: {
      type: Array,
      default: function () {
        return this.$store.state.options.shadowConfig
      }
    },
    boxShadow: {
      type: Object
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default:20
    },
    hasSeColor: {
      type: Boolean,
      default: true
    },
    color_title: {
      type: String,
      default: i18n.t('view_back_top_edit_103')
    },
    secolor_title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      /* min: 0,
      max: 100, */
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.my-label {
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  margin-bottom: 12px;
}

.color-picker {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 12px;
  /deep/ .set_two_level {
    margin-bottom: 0 !important;
  }
}

.shadow-setting .num-blur {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/my_simple_box_shadow/index.vue